import { object } from "yup";
import { nonEmptyRequiredString, practitioner } from "../shared.js";
import { disclosureHarmfulSchema, soadAssessmentCompletionStatusSchema, } from "./helpers.js";
import { exampleSRFData } from "./srf.js";
export const soadT6Part1DataSchema = object({
    practitioner: practitioner(),
    treatment: nonEmptyRequiredString.required("Please include a description of treatment or plan of treatment"),
    reasons: nonEmptyRequiredString.required("Please include your reasons"),
    disclosureHarmful: disclosureHarmfulSchema,
    completionStatus: soadAssessmentCompletionStatusSchema,
});
// Example data
const patient = {
    name: "John Doe",
    address: "123 address",
    postalCode: "SE4",
    dateOfBirth: null,
};
const user = {
    name: "Dr Bob",
    email: "bob@bob.com",
    address: "123 hospital",
    postalCode: "SE5",
    isGuest: false,
    isConfirmed: true,
};
export const exampleSoadT6Data = [
    {
        data: {
            practitioner: user,
            treatment: "TREATMENT",
            reasons: "REASONS",
            disclosureHarmful: false,
            completionStatus: "completed",
        },
        context: {
            patient,
            user,
            formContext: { officialReferenceId: "1233445" },
            srfData: exampleSRFData.map(({ data }) => data),
        },
    },
];
//# sourceMappingURL=soad-t6.js.map